module.exports = __webpack_public_path__ + "static/card-expenses-ecd4145d43a7e02454e8ceca3ff852b9.png";